export enum ProductCategories {
    customers = 'Customers',
    projects = 'Projects',
}
